import { Directive, HostListener } from "@angular/core";
import { LoggingService } from "../../logging.service";
import { IUiLoggerPayload } from "../../logging.model";

//for input change. 
@Directive({
  selector: '[ngModel],[formControl],[formControlName]',
})
export class NgModelDirective {

  constructor(
    private logger: LoggingService
  ) { }

  @HostListener('focusout', ['$event'])
  onBlur(event: FocusEvent) {
    const target = event.target as HTMLInputElement;
    if (target.type === 'password') return; // do not log password fields for security reasons

    const tag = target.tagName?.toLowerCase();
    const text = target.name|| target.getAttribute('placeholder') || 'Unknown Field';
    const id = target.id || undefined;
    const classes = target.className || undefined;
    this.logUi({
      context: "INPUT",
      element: target,
      tag,
      text,
      id,
      classes,
    });
  }

  /**
   * internal function to log the click event.
   * @param element clickable element information
   */
  protected logUi(element: IUiLoggerPayload) {
    this.logger.logUi(element);
  }
}
